import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { withRouter } from "react-router-dom";
import _ from "lodash";
import CircleTimer from "../circleTimer";
import Socket from "../../socket/socket";

class VerbodenTimer extends React.Component {
  constructor(props) {
    super(props);
    const { timer } = props.game3Reducer;
    const getTimerValues = this.setTimerValues(timer);
    this.state = {
      temp: timer,
      seconds: timer,
      time: { m: getTimerValues.minutes, s: getTimerValues.initiaSec },
      // timeReset: true,
    };
  }

  setTimerValues(timer) {
    let divisor_for_minutes = timer % (60 * 60);
    let minutes = Math.floor(divisor_for_minutes / 60);
    let divisor_for_seconds = divisor_for_minutes % 60;
    let initiaSec = Math.ceil(divisor_for_seconds);
    return {
      minutes,
      initiaSec,
    };
  }

  componentDidMount() {
    const tenSecTrack = _.get(
      this,
      "props.paramsReducer.gameObj.tabletop_ten_seconds_sound"
    );
    this.setState({ tenSecTrack });
  }

  componentDidUpdate(prevProps) {
    const { timer } = this.props.game3Reducer;
    const prevroomData = prevProps.gameReducer.roomObj;
    const prevUser = prevProps.gameReducer.roomObj.users;
    const roomData = this.props.gameReducer.roomObj;
    const users = this.props.gameReducer.roomObj.users;

    if (prevUser?.length !== users?.length) {
      const getTimerValues = this.setTimerValues(timer);
      this.setState({
        temp: timer,
        seconds: timer,
        time: { m: getTimerValues.minutes, s: getTimerValues.initiaSec },
      });
    }

    if (roomData?.game_state?.status === "PreGuess") {
      if (
        prevroomData?.game_state?.status === "ResultTurn" ||
        prevroomData?.game_state?.status === "ResultRound"
      ) {
        const getTimerValues = this.setTimerValues(timer);
        this.setState({
          temp: timer,
          seconds: timer,
          time: { m: getTimerValues.minutes, s: getTimerValues.initiaSec },
        });
      }
    }
    if (roomData?.game_state?.status === "ResultTurn") {
      if (prevroomData?.game_state?.status === "Guessing") {
        clearInterval(this.timerofGame);
        const getTimerValues = this.setTimerValues(timer);
        this.setState({
          temp: 0,
          seconds: 0,
          time: { m: 0, s: 0 },
        });
      }
    }
    if (prevroomData?.game_state?.status === "PreGuess") {
      if (roomData?.game_state?.status === "Guessing") {
        this.timerofGame = setInterval(() => this.countDown(), 1000);
      }
    }
    if (prevroomData?.game_state?.status === "Guessing") {
      if (roomData?.game_state?.status === "PreGuess") {
        clearInterval(this.timerofGame);
      }
    }

    if (roomData?.game_state?.status === "Guessing") {
      if (
        prevroomData?.game_state?.status === "Guessing" &&
        this.state.timeReset
      ) {
        this.timerofGame = setInterval(() => this.countDown(), 1000);
        // this.setState({
        //   timeReset: false,
        // });
      }
    }
  }

  secondsToTime = (secs) => {
    let hours = Math.floor(secs / (60 * 60));

    let divisor_for_minutes = secs % (60 * 60);
    let minutes = Math.floor(divisor_for_minutes / 60);

    let divisor_for_seconds = divisor_for_minutes % 60;
    let seconds = Math.ceil(divisor_for_seconds);

    let obj = {
      h: hours,
      m: minutes,
      s: seconds,
    };
    return obj;
  };

  countDown = () => {
    const roomData = this.props.gameReducer.roomObj;
    const status = _.get(roomData, "game_state.status");
    if (status === "Over") {
      clearInterval(this.timerofGame);
    }
    // Remove one second, set state so a re-render happens.
    let secondsT = this.state.seconds > 0 ? this.state.seconds - 1 : 0;
    this.setState({
      time: this.secondsToTime(secondsT),
      seconds: secondsT,
    });
    // Check if we're at zero.
    if (secondsT === 0) {
      // this.props.history.push("/verboden/result");
      if (
        roomData &&
        roomData.game_state &&
        (status !== "ResultTurn" || status !== "ResultRound")
      ) {
        let obj = {
          action: "update-status",
          roomId: roomData.id,
        };
        setTimeout(() => {
          Socket.sendMessage(obj);
        }, 1500);
      }
      clearInterval(this.timerofGame);
    }
  };

  playATrack = () => {
    const callAudioEl = document.getElementById("tenSecTrack");
    if (callAudioEl) {
      callAudioEl
        .play()
        .then(() => {})
        .catch(() => {});
    }
  };

  render() {
    const { temp, tenSecTrack, seconds } = this.state;
    const t = temp > 0 ? 100 / temp : 0;
    const t2 = t * seconds;
    let secondToShow = this.state.time.s;
    if (this.state.time.s < 10) {
      secondToShow = "0" + this.state.time.s;
    } else if (this.state.time.s === 10 && this.state.time.m === 0) {
      this.playATrack();
    }
    return (
      <>
        <audio id="tenSecTrack" src={tenSecTrack}></audio>
        <div className="p-4 vb-timer">
          <CircleTimer
            count={t2}
            time={`${this.state.time.m}:${secondToShow}`}
            buzzInfo={this.props.buzzInfo}
          />{" "}
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
  game3Reducer: state.game3Reducer,
  paramsReducer: state.paramsReducer,
});

export default compose(
  withRouter,
  connect(mapStateToProps, null)
)(VerbodenTimer);
